import { Asset, AssetStatus } from '@flatsy/types/Assets'

// pas utilisé
/**
 * @description check if asset is CLOSED and return true or false
 * @param a Single Asset object
 * @returns boolean
 */
export const isAssetClosed = (a: Asset): boolean => {
  if (a.status === AssetStatus.CLOSED) {
    return true
  }

  return false
}

export const isPublicAssetFromLamyNetwork = (asset?: Asset): boolean => {
  return !!asset?.network_enable_sigeo_fields
}
